import sr1sr2BannerImg from 'public/asset/product/deepfield/01-section-2/01-SR12/SR12-content1-img@2x.png';
import sr1sr2ProductDescImg from 'public/asset/product/deepfield/01-section-2/01-SR12/SR12-content2-img@2x.png';
const sr1sr2Video1 = require('public/asset/videos/01-SR12/01/01-video.mp4');
const sr1sr2Video2 = require('public/asset/videos/01-SR12/02/02-video.mp4');
const sr1sr2Video3 = require('public/asset/videos/01-SR12/03/03-video.mp4');
import modelPicto1 from 'public/asset/product/deepfield/02-section-3/01-SR12/content2/icon-1@2x.png';
import modelPicto2 from 'public/asset/product/deepfield/02-section-3/01-SR12/content2/icon-2@2x.png';
import sr1sr2ProductDevicesPlaformsPict1 from 'public/asset/product/deepfield/03-section-4/pictogram/pictogram-1@2x.png';
import sr1sr2ProductDevicesPlaformsPict2 from 'public/asset/product/deepfield/03-section-4/pictogram/pictogram-2@2x.png';
import sr1sr2ProductDevicesPlaformsBg1 from 'public/asset/product/deepfield/03-section-4/bg/section4-bg-1@2x.png';
import sr1sr2ProductDevicesPlaformsBg2 from 'public/asset/product/deepfield/03-section-4/bg/section4-bg-2@2x.png';

// ##### sr3
import sr3BannerImg from 'public/asset/product/deepfield/01-section-2/02-SR3/SR3-content1-img@2x.png';
import sr3ProductDescImg from 'public/asset/product/deepfield/01-section-2/02-SR3/SR3-content2-img@2x.png';
const sr3Video1 = require('public/asset/videos/02-SR3/01/01-video.mp4');
const sr3Video2 = require('public/asset/videos/02-SR3/02/02-video.mp4');

// ##### pqo
import pqoBannerImg from 'public/asset/product/deepfield/01-section-2/03-PQO/PQO-content1-img@2x.png';
import pqoProductDescImg from 'public/asset/product/deepfield/01-section-2/03-PQO/PQO-content2-img@2x.png';
const pqoVideo1 = require('public/asset/videos/03-PQO/01-video.mp4');

// ## av1
import av1BannerImg from 'public/asset/product/pulsar/04-AV1/AV1-content1-img@2x.png';
import av1ProductDescImg from 'public/asset/product/pulsar/04-AV1/AV1-content2-img@2x.png';
import av1Graph1Img from 'public/asset/product/pulsar/04-AV1/AV1-section3-graph1@2x.png';
import av1Graph2Img from 'public/asset/product/pulsar/04-AV1/AV1-section3-graph2@2x.png';
const av1Video1 = require('public/asset/videos/04-AV1/02-video.mp4');

// ## avif
import avifBannerImg from 'public/asset/product/pulsar/05-AVIF/AVIF-content1-img@2x.png';
import avifProductDescImg from 'public/asset/product/pulsar/05-AVIF/AVIF-content2-img@2x.png';
const avifPerformanceVideoMobile = require('public/asset/videos/05-AVIF/video-s.mp4');
const avifPerformanceVideoDesktop = require('public/asset/videos/05-AVIF/video-xl.mp4');

// ## vmaf
import vmafBannerImg from 'public/asset/product/pulsar/06-VMAF/VMAF-content1-img@2x.png';
import vmafProductDescImg from 'public/asset/product/pulsar/06-VMAF/VMAF-content2-img@2x.png';
import vmafPerfoSImg from 'public/asset/product/pulsar/06-VMAF/VMAF-section3-graph1-S@2x.png';
import vmafPerfoXLImg from 'public/asset/product/pulsar/06-VMAF/VMAF-section3-graph1-XL@2x.png';
import Av1PQOCustomLink from 'components/Product/Molcules/Feature/Av1PQOCustomLink';
import { ReactNode } from 'react';
import Av1MSU from 'components/Product/Pulsar/Av1MSU';

export const pulsarContents = {
  av1: {
    banner: {
      bannerImg: av1BannerImg,
      bannerTitle: 'Pulsar-AV1',
      bannerText: {
        ko: '차세대 동영상 압축 포맷인 AV1 코덱을 반도체 설계 기술로 개발한 고성능 인코더 IP 입니다.',
        en: 'A high-performance AV1 encoder, the next generation video codec format, developed using semiconductor design technologies',
      },
    },
    productDescription: {
      productDescriptionImg: av1ProductDescImg,
      productTitle: {
        ko: ['기존 코덱보다 적은 데이터로', '더 많은 비디오를 지원'],
        en: ['Supports more videos with less data than traditional codecs'],
      },
      productText: {
        ko: [
          '증가하는 동영상 트래픽에 따른 데이터 저장 및 송출 비용 상승에 대한 부담이 커지고 있습니다. 압축효율이 높은 차세대 코덱 표준인 AV1이 기존 H.264의 대안이 되고 있습니다. 그러나 소프트웨어 기반의 코덱은 높은 연산량 때문에 추가적인 컴퓨팅 비용 상승이 불가피하여 코덱 교체가 쉽지 않습니다.',
          '블루닷은 반도체 설계 기술로 AV1 인코딩의 속도를 높이고 비용을 절감하였습니다.',
        ],
        en: [
          'Due to an increase in video traffic, expenses associated with data storage and network are rising. AV1, the next-generation codec standard with high compression efficiency, is becoming an alternative to the existing H.264. However, due to high computational load, software-based AV1 encoder requires further computational cost increases, making codec replacement difficult.',
          'BLUEDOT leverages semiconductor design technology to accelerate and lower the cost of AV1 encoding.',
        ],
      },
    },
    productFeatures: {
      featureItems: [
        {
          featureName: {
            ko: 'Pulsar-AV1 인코더 IP 성능',
            en: 'Pulsar-AV1 encoder performance',
          },
          featureText: {
            ko: [
              'AV1 반도체 인코더 IP는 FPGA(e.g. 자일링스 알베오 U250, U55c 카드) 기반으로 가속되며 저지연 인코딩에 적합합니다.',
              'CPU 기반의 svt-av1 대비 6배 이상의 빠른 속도로 인코딩을 할 수 있으며 높은 압축 성능을 보입니다.',
            ],
            en: [
              'AV1 encoder is FPGA-accelerated and suitable for low-latency encoding. Compared to CPU-based svt-av1, encoding performs at a 6x faster speed and shows higher compression efficiency.',
            ],
          },
          vids: [],
          imgs: [av1Graph1Img, av1Graph2Img],
          wrapMedia: true,
        },
        {
          featureName: {
            ko: 'nVIDIA, Intel, AMD보다 크게 앞서고 글로벌 벤치마크에서 검증된 압축률',
            en: 'Top 3 best video encoder in MSU Hardware Video Codec Comparison',
          },
          featureText: {
            ko: '',
            en: '',
          },
          imgs: [],
          vids: [],
          customComponent: Av1MSU,
        },
        {
          featureName: {
            ko: 'Pulsar-AV1 인코더 IP 화질',
            en: 'Quality of Pulsar-AV1 encoder IP',
          },
          featureText: {
            ko: [],
            en: [],
          },
          vids: [av1Video1],
          mobileVids: [av1Video1],
        },
        {
          featureName: {
            ko: 'Pulsar-AV1 인코더 비트 전송률 효율성',
            en: 'Pulsar-AV1 encoder bitrate efficiency',
          },
          featureText: {
            // ko: [
            //   '블루닷의 인지화질 최적화 제품과 연동하여 추가적인 압축 효율 향상이 가능합니다.',
            // ],
            // en: [
            //   "It is possible to further improve the encoding efficiency by taking advantage of BLUEDOT's AI based Perceptual Quality Optimizer.",
            // ],
            ko: [],
            en: [],
          },
          vids: [],
          customComponent: Av1PQOCustomLink as ({
            locale,
          }: {
            locale: string;
          }) => ReactNode,
          link: {
            label: {
              ko: 'PQO 살펴보기',
              en: 'See the details of DeepField-PQO',
            },
            href: {
              ko: '/product/pqo/#product-section',
              en: '/product/pqo/#product-section',
            },
          },
        },
      ],
    },
    devicesPlatforms: [
      {
        platform: { ko: '온프레미스', en: 'On premise' },
        device: {
          ko: '자일링스 알베오 U250 카드',
          en: 'XILINX ALVEO U250 CARD',
        },
        bgImg: sr1sr2ProductDevicesPlaformsBg1.src,
        pictogram: sr1sr2ProductDevicesPlaformsPict2.src,
      },
      {
        platform: { ko: '클라우드', en: 'Cloud' },
        device: {
          ko: 'MS Azure NP 인스턴스',
          en: 'MS AZURE NP Instance',
        },
        bgImg: sr1sr2ProductDevicesPlaformsBg2.src,
        pictogram: sr1sr2ProductDevicesPlaformsPict1.src,
      },
    ],
    devicesPlatformsDesc: {
      ko: '자일링스 FPGA 디바이스에 최적화 하였으며 반도체 IP로 구현되었습니다.',
      en: 'Pulsar-AV1 is implemented into Silicon IP optimal for AMD/Xilinx FPGAs.',
    },
    productProvide: [
      {
        name: 'SDK',
        text: {
          ko: 'FPGA 가속 카드에 최적화된 SDK 형태로 제공되며 FFmpeg 프레임워크 지원으로 어떠한 미디어 워크플로우에도 간단히 통합될 수 있습니다.',
          en: 'Provided as an SDK optimized for FPGA accelerator cards and as it runs under FFmpeg framework, making it simple to integrate into your media workflow.',
        },
      },
      {
        name: 'Silicon IP',
        text: {
          ko: '블루닷의 딥필드 제품은 서버용 미디어 프로세싱 FPGA 또는 ASIC에 통합될 수 있는 반도체 IP으로도 제공되며, 최고의 성능을 경험할 수 있습니다.',
          en: 'The product is also available as Semiconductor IP that can be integrated into media processing FPGAs or ASICs for servers for optimal performance.',
        },
      },
    ],
  },
  avif: {
    banner: {
      bannerImg: avifBannerImg,
      bannerTitle: 'Pulsar-AVIF',
      bannerText: {
        ko: 'JPEG 대비 화질의 열화없이 50% 이하의 파일 크기로 압축할 수 있는 반도체 설계 기술 기반의 고성능 AVIF 이미지 인코더 입니다.',
        en: 'It is a high-performance AVIF image encoder developed leveraging semiconductor design technology that reduces file size by 50% or less without sacrificing quality as compared to JPEG.',
      },
    },
    productDescription: {
      productDescriptionImg: avifProductDescImg,
      productTitle: {
        ko: ['사진의 용량과 네트워크', '사용을 반으로'],
        en: ['Cut storage and', 'network usage in half'],
      },
      productText: {
        ko: [
          '웹페이지 데이터의 50% 이상이 이미지로 구성되어 있으며 고화질.고해상도 사진의 사용 선호가 높아지고 있습니다. 늘어가는 이미지의 비중은 이커머스 웹페이지의 로딩 시간을 느리게 하고 네트워크 비용 상승의 원인이 됩니다.',
          'JPEG 이미지 압축 코덱을 대신할 수 있는 AVIF 인코더는 높은 연산량으로 인한 느린 속도가 문제입니다.',
          '블루닷은 반도체 설계 기술을 이용하여 매우 빠른 이미지 압축이 가능한 AVIF 인코더 IP를 개발하였습니다.',
        ],
        en: [
          'Images make up more than half of web page data, and the preference for high-quality, high-resolution images is booming. The increasing usage of images in online pages delays loading times and raises network expenses.',
          'The AVIF encoder, which is the next generation codec for replacing JPEG, has a slow performance issue due to a high computation complexity.',
          'BLUEDOT provides an FPGA-accelerated AVIF encoder capable of extremely fast image compression that is developed using semiconductor design technologies.',
        ],
      },
    },
    productFeatures: {
      featureItems: [
        {
          featureName: {
            ko: 'AVIF 지원 운영체제 및 브라우저 증가',
            en: 'A growing number of AVIF-compliant operating systems and browsers',
          },
          featureText: {
            ko: [
              '윈도우10와 안드로이드 12 운영체제 그리고 크롬, 파이어폭스등의 주요 웹브라우저에서 지원되고 있습니다. 그리고 최근 iOS16에서 AVIF 지원 발표로 사파리에서도 사용이 가능해짐에 따라 현존하는 대부분의 웹브라우저에서 AVIF 이미지 파일을 오픈할 수 있게 되었습니다.',
            ],
            en: [
              'Windows 10 and Android 12 operating systems, as well as major web browsers such as Chrome, and Firefox, all support AVIF format. With the recent addition of AVIF format compatibility in iOS16 and Safari, AVIF image files may now be opened in the majority of existing web browsers.',
            ],
          },
          vids: [],
        },
        {
          featureName: {
            ko: 'Pulsar-AVIF 인코더 IP 성능',
            en: 'Pulsar-AVIF encoder performance',
          },
          featureText: {
            ko: [
              'AVIF 반도체 인코더 IP는 FPGA(e.g. 자일링스 알베오 U250, U55c 카드) 기반으로 가속됩니다. CPU를 사용하는 소프트웨어 AVIF 인코더와 비교하여 21배 빠르게 인코딩 할 수 있습니다.',
            ],
            en: [
              'AVIF encoder is FPGA(e.g AMD/Xilinx Alveo U250, U55C card) accelerated and performs 21 times faster than the CPU-based AVIF encoder.',
            ],
          },
          artDirection: true,
          imgs: [],
          vids: [avifPerformanceVideoMobile, avifPerformanceVideoDesktop],
        },
        // {
        //   featureName: {
        //     ko: 'JPEG과 블루닷 AVIF의 화질 비교',
        //     en: 'A comparison of JPEG and Pulsar-AVIF image quality',
        //   },
        //   popup: [],
        //   featureText: {
        //     ko: [],
        //     en: [],
        //   },
        //   vids: [],
        //   wrapMedia: false,
        //   imgs: [],
        // },
      ],
    },
    devicesPlatforms: [
      {
        platform: { ko: '온프레미스', en: 'On premise' },
        device: {
          ko: '자일링스 알베오 카드',
          en: 'Xilinx ALVEO Card',
        },
        bgImg: sr1sr2ProductDevicesPlaformsBg1.src,
        pictogram: sr1sr2ProductDevicesPlaformsPict2.src,
      },
      {
        platform: { ko: '클라우드', en: 'Cloud' },
        device: {
          ko: 'MS Azure NP 시리즈 인스턴스',
          en: 'MS Azure NP-Series Instances',
        },
        bgImg: sr1sr2ProductDevicesPlaformsBg2.src,
        pictogram: sr1sr2ProductDevicesPlaformsPict1.src,
      },
    ],
    devicesPlatformsDesc: {
      ko: 'AVIF 인코더는 반도체 IP로 구현되었습니다.',
      en: 'Pulsar-AV1 is implemented into Silicon IP optimal for AMD/Xilinx FPGAs.',
    },
    productProvide: [
      {
        name: 'SDK',
        text: {
          ko: 'FPGA 가속 카드에 최적화된 SDK 형태로 제공되며 FFmpeg 프레임워크 지원으로 어떠한 미디어 워크플로우에도 간단히 통합될 수 있습니다.',
          en: 'Provided as an SDK optimized for FPGA accelerator cards and as it runs under FFmpeg framework, making it simple to integrate into your media workflow.',
        },
      },
      {
        name: 'Silicon IP',
        text: {
          ko: '블루닷의 딥필드 제품은 서버용 미디어 프로세싱 FPGA 또는 ASIC에 통합될 수 있는 반도체 IP으로도 제공되며, 최고의 성능을 경험할 수 있습니다.',
          en: 'The product is also available as Semiconductor IP that can be integrated into media processing FPGAs or ASICs for servers for optimal performance.',
        },
      },
    ],
  },
  vmaf: {
    banner: {
      bannerImg: vmafBannerImg,
      bannerTitle: 'Pulsar-VMAF',
      bannerText: {
        ko: '오픈소스보다 빠르게 VMAF 품질 평가 알고리즘을 가속하여 영상의 품질을 측정합니다.',
        en: 'It measures VMAF, a video quality metric, faster than open source.',
      },
    },
    productDescription: {
      productDescriptionImg: vmafProductDescImg,
      productTitle: {
        ko: ['매우 빠른', 'VMAF 가속기'],
        en: ['Very fast', 'VMAF accelerator'],
      },
      productText: {
        ko: [
          '영상의 품질을 인간의 주관적(지각적) 수준으로 평가 해야할 필요성이 높아졌습니다. 넷플릭스가 공개한 VMAF가 널리 사용되고 있으나 높은 연산량으로 컴퓨팅 비용과 처리 시간에 대한 부담이 발생합니다.',
          '블루닷은 반도체 설계 기술을 이용하여 VMAF 전용 가속 IP로 구현하였기 때문에 비용 부담을 줄일 수 있습니다.',
        ],
        en: [
          "There is an increasing need to measure video quality on a human subjective (perceptual) level. Although Netflix's VMAF is extensively used, its large computational load places a strain on computer expenses and processing time.",
          'BLUEDOT lowers the cost burden since it develops a VMAF-specific accelerator using semiconductor design techniques.',
        ],
      },
    },
    productFeatures: {
      featureItems: [
        {
          featureName: {
            ko: '늘어가는 VMAF 적용 서비스',
            en: 'VMAF becoming widely used metric',
          },
          featureText: {
            ko: [
              '사업자는 동영상별(per-title) 가장 최적화된 (비트율, 해상) 조합을 찾아서 서비스함으로써 저장.전송 비용 절감과 동시에 사용자의 시청 경험을 향상시키려고 합니다.',
            ],
            en: [
              "Service Providers try to find the optimal combination(bit rate, resolution) for each video or shot so as to save storage and network costs while improving the user's viewing experience. Encoding and VMAF quality measuring must be done dozens of times to find the optimal combination, which necessitates a significant amount of computation resources. By leveraging BLUEDOT's semiconductor design technology, you can speed up VMAF quality measurements and reduce computing costs.",
            ],
          },
          vids: [],
          imgs: [],
        },
        {
          featureName: {
            ko: 'Pulsar-VMAF 성능',
            en: 'Pulsar-VMAF Performance',
          },
          featureText: {
            ko: [
              '블루닷의 VMAF 반도체 IP는 FPGA 기반으로 가속됩니다. CPU 기반의 오픈 소스보다 x4 빠른 VMAF 품질 측정이 가능하고 컴퓨팅 비용이 x3 절감 됩니다.',
            ],
            en: [
              'FPGA-accelerated VMAF is x4 faster than CPU-based open source and x3 lower in compute costs.',
            ],
          },
          artDirection: true,
          vids: [],
          imgs: [vmafPerfoXLImg, vmafPerfoSImg],
        },
      ],
    },
    devicesPlatforms: [
      {
        platform: { ko: '온프레미스', en: 'On premises' },
        device: {
          ko: '자일링스 알베오 U50, U55c 카드',
          en: 'Xilinx ALVEO U50, U55c CARD',
        },
        bgImg: sr1sr2ProductDevicesPlaformsBg1.src,
        pictogram: sr1sr2ProductDevicesPlaformsPict2.src,
      },
      {
        platform: { ko: '클라우드', en: 'Cloud' },
        device: {
          ko: 'MS Azure NP 인스턴스, AWS EC2 f1 인스턴스',
          en: 'MS Azure NP10 instances, AWS EC2 f1 instances',
        },
        bgImg: sr1sr2ProductDevicesPlaformsBg2.src,
        pictogram: sr1sr2ProductDevicesPlaformsPict1.src,
      },
    ],
    devicesPlatformsDesc: {
      ko: '인공지능 모델의 경량화를 통해 지원 디바이스에 최적화 하였으며 반도체 IP로 구현되었습니다.',
      en: 'Pulsar-VMAF is implemented into Silicon IP optimal for AMD/Xilinx FPGAs.',
    },
    productProvide: [
      {
        name: 'SDK',
        text: {
          ko: 'FPGA 가속 카드에 최적화된 SDK 형태로 제공되며 FFmpeg 프레임워크 지원으로 어떠한 미디어 워크플로우에도 간단히 통합될 수 있습니다.',
          en: 'Provided as an SDK optimized for FPGA accelerator cards and as it runs under FFmpeg framework, making it simple to integrate into your media workflow.',
        },
      },
      {
        name: 'Silicon IP',
        text: {
          ko: '블루닷의 딥필드 제품은 서버용 미디어 프로세싱 FPGA 또는 ASIC에 통합될 수 있는 반도체 IP으로도 제공되며, 최고의 성능을 경험할 수 있습니다.',
          en: 'The product is also available as Semiconductor IP that can be integrated into media processing FPGAs or ASICs for servers for optimal performance.',
        },
      },
    ],
  },
};

export const deepfieldContents = {
  sr: {
    banner: {
      bannerImg: sr1sr2BannerImg,
      bannerTitle: 'DeepField-SR',
      bannerText: {
        ko: '인공지능 기반의 초해상화 기술로써 동영상의 시・공간적 정보를 활용하여 고화질 및 고해상도의 영상으로 변환합니다.',
        en: 'It is an AI-powered Super Resolution technology that upscales videos to high resolution and improves video quality by using temporal and spatial information.',
      },
    },
    productDescription: {
      productDescriptionImg: sr1sr2ProductDescImg,
      productTitle: {
        ko: ['디테일을 살린 또렷한', '화질개선 솔루션'],
        en: ['Eliminate encoding', 'noise and artifacts'],
      },
      productText: {
        ko: [
          '슈퍼레졸루션은 노이즈 제거, 영상 화질 향상, 그리고 업스케일링등의 영상 처리 알고리즘들로 구성되어 있습니다.',
          '각각의 알고리즘들을 위한 뉴럴 네트워크 모델은 저화질.저해상도 입력 영상으로부터 고화질.고해상도의 우수한 품질의 영상을 예측할 수 있도록 수 많은 비디오 데이터세트로 학습됩니다.',
          '연속된 비디오 프레임들간의 시간적 정보를 활용하여 더 자연스럽고 향상된 화질의 영상으로 생성합니다.',
        ],
        en: [
          'Video SR consists of video processing algorithms such as noise removal, image quality enhancement, and upscaling.',
          'For each algorithm, Neural Network model is trained on a large number of video For each algorithm, Neural Network model is trained on a large number of video',
          'It makes advantage of the temporal information from multiple video frames to provide a more realistic and better visual quality.',
        ],
      },
    },
    productFeatures: {
      aiModelSelection: {
        briefText: {
          ko: '동영상 서비스 목적에 따라 최적화된 두 가지 다른 모델을 제공합니다.',
          en: 'We provide two separate AI models that are tailored to serve various video service needs.',
        },
        modelItems: [
          {
            modelPictoImg: modelPicto1.src,
            modelName: {
              ko: ['성능 모델'],
              en: ['Performance focused model'],
            },
            modelDesc: {
              ko: '최고의 성능으로 라이브 스트리밍에 적용해야 하는 경우',
              en: 'Applied for a live streaming with the highest level of performance',
            },
          },
          {
            modelPictoImg: modelPicto2.src,
            modelName: {
              ko: ['품질 모델'],
              en: ['Quality focused model'],
            },
            modelDesc: {
              ko: '최상의 품질로 고해상도 업스케일링해야 하는 경우',
              en: 'Applied for better enhancement quality and upscaling resolution',
            },
          },
        ],
      },
      featureItems: [
        {
          featureName: {
            ko: '인코딩 노이즈 및 아티팩트 제거',
            en: 'Remove encoding noise and artifact',
          },
          featureText: {
            ko: [
              '노이즈 및 아티팩트 제거 알고리즘의 학습으로 동영상 손실 압축시 발생하는 인코딩 아티팩트(블럭킹)를 제거하고 디테일을 보존합니다.',
            ],
            en: [
              'The trained Neural Network for the noise and artifacts removing algorithm removes encoding artifacts (blocking) that occur during video lossy compression and preserves details.',
            ],
          },
          mobileVids: [sr1sr2Video1],
          vids: [sr1sr2Video1],
        },
        {
          featureName: {
            ko: '영상 화질 향상 및 업스케일링',
            en: 'Enhancing video quality and upscaling video resolution',
          },
          featureText: {
            ko: [
              '학습된 인공지능 모델이 섬세한 텍스쳐를 추가 하고 선명도를 향상시켜 고해상도의 영상으로 생성합니다.',
            ],
            en: [
              'The trained AI model enhances clarity and adds delicate textures to produce high quality videos.',
            ],
          },
          mobileVids: [sr1sr2Video2],
          vids: [sr1sr2Video2],
        },
        {
          featureName: {
            ko: '동영상의 시간적 정보 활용',
            en: 'Use the temporal information from video',
          },
          featureText: {
            ko: [
              '연속된 비디오의 프레임들간 정보를 활용하여 싱글 프레임 기반의 초해상화 기술에서 발생하는 모션 블러나 떨림 효과를 크게 줄였습니다.',
            ],
            en: [
              'The motion blur that typically arises in single-frame-based upscaling has been significantly minimized by combining temporal information from many frames.',
            ],
          },
          mobileVids: [sr1sr2Video3],
          vids: [sr1sr2Video3],
        },
      ],
    },
    devicesPlatformsDesc: {
      ko: '인공지능 모델의 경량화를 통해 지원 디바이스에 최적화 하였으며 소프트웨어 그리고 반도체 IP로 구현되었습니다.',
      en: 'A light-weighted AI model implemented into software and semiconductor IP that is designed for supported devices',
    },
    devicesPlatforms: [
      {
        platform: { ko: '온프레미스', en: 'On premises' },
        device: {
          ko: '엔비디아 GPU 카드, 자일링스 알베오 FPGA 카드',
          en: 'Nvidia GPU Card, Xilinx ALVEO FPGA Card',
        },
        bgImg: sr1sr2ProductDevicesPlaformsBg1.src,
        pictogram: sr1sr2ProductDevicesPlaformsPict2.src,
      },
      {
        platform: { ko: '클라우드', en: 'Cloud' },
        device: {
          ko: 'AWS EC2 인스턴스, MS Azure NP 인스턴스',
          en: 'AWS EC2 instances, MS Azure NP instances',
        },
        bgImg: sr1sr2ProductDevicesPlaformsBg2.src,
        pictogram: sr1sr2ProductDevicesPlaformsPict1.src,
      },
    ],
    productProvide: [
      {
        name: 'SDK',
        text: {
          ko: 'GPU/FPGA 가속 카드에 최적화된 SDK 형태로 제공되며 FFmpeg 프레임워크 지원으로 어떠한 미디어 워크플로우에도 간단히 통합될 수 있습니다.',
          en: 'Provided as an SDK optimized for GPU/FPGA accelerator cards and supports the FFmpeg framework, making it simple to integrate into your media workflow.',
        },
      },
      {
        name: 'Silicon IP',
        text: {
          ko: '블루닷의 딥필드 제품은 서버용 미디어 프로세싱 FPGA 또는 ASIC에 통합될 수 있는 반도체 IP으로도 제공되며, 최고의 성능을 경험할 수 있습니다.',
          en: 'DeepField products are also available as Semiconductor IP that can be integrated into media processing FPGAs or ASICs for servers for optimal performance.',
        },
      },
      {
        name: 'UI Service',
        text: {
          ko: '서비스 사업자를 위한 파일 기반의 영상 변환 클라우드 서비스를 제공합니다.',
          en: 'Offers file-based video upscaling cloud service for content providers',
        },
      },
    ],
  },
  // ################################################################ sr3 ################################################################
  sr3: {
    banner: {
      bannerImg: sr3BannerImg,
      bannerTitle: 'DeepField-SR3',
      bannerText: {
        ko: '컴퓨터 비전의 성능을 높이기 위해 화질이 개선된 영상 데이터 입력을 제공합니다.',
        en: 'Improve better and more effective visual data input, which boosts computer vision performance.',
      },
    },
    productDescription: {
      productDescriptionImg: sr3ProductDescImg,
      productTitle: {
        ko: ['화질 개선으로 컴퓨터 비전', '시스템의 효율을 향상'],
        en: [
          'Enhancing image quality improves',
          'the efficiency of computer vision systems',
        ],
      },
      productText: {
        ko: [
          '영상내 정보의 해석 가능성 또는 정보 인식의 확률을 높이기 위해 화질 개선이 필요합니다.',
          '블루닷의 인공지능 모델은 조도를 개선하고 노이즈를 절감할 수 있도록 수 많은 이미지, 비디오 데이터셋으로 학습되었습니다.',
          '특히, 의미 있는 객체를 분류하는 영상 분석 기술 그리고 문서 이미지내에서의 텍스트 또는 차량 번호판 등의 인식 기술에 도움이 되는 화질 개선에 특화되어 있습니다.',
        ],
        en: [
          'It is required to enhance video quality to boost the interpretability of information or the probability of recognition in video.',
          "BLUEDOT's proprietary AI model is trained on various image and video datasets to improve low light and remove noise.",
          'It specializes in video analysis technology to identify relevant objects and video quality enhancement to support text or license plate recognition.',
        ],
      },
    },
    productFeatures: {
      featureItems: [
        {
          featureName: {
            ko: '조도 개선',
            en: 'Low light image enhancement',
          },
          featureText: {
            ko: [
              '어두운 환경에서 촬영된 영상을 개선하여 객체에 대한 정보 식별의 비율을 높일 수 있습니다.',
            ],
            en: [
              'By making improvements of light to the video taken in a dark environment, object detection may increase.',
            ],
          },
          mobileVids: [sr3Video1],
          vids: [sr3Video1],
        },
        {
          featureName: {
            ko: '이미지 내 텍스트 선명도 개선',
            en: 'Text sharpness improvement',
          },
          featureText: {
            ko: [
              '이미지내의 품질 낮은 텍스트 선명도를 개선하여 문자 인식률과 정확도를 높일 수 있습니다.',
            ],
            en: [
              'Sharpening the poor-quality text in the image will improve text recognition accuracy.',
            ],
          },
          mobileVids: [sr3Video2],
          vids: [sr3Video2],
        },
      ],
    },
    devicesPlatformsDesc: {
      ko: '인공지능 모델의 경량화를 통해 지원 디바이스에 최적화 하였으며 소프트웨어 그리고 반도체 IP로 구현되었습니다.',
      en: 'A light-weighted AI model implemented into software and semiconductor IP that is designed for supported devices',
    },
    devicesPlatforms: [
      {
        platform: { ko: '온프레미스', en: 'On premises' },
        device: {
          ko: '엔비디아 GPU 카드, AMD/자일링스 알베오 FPGA 카드',
          en: 'NVidia GPU Card, AMD/Xilinx Alveo FPGA Card',
        },
        bgImg: sr1sr2ProductDevicesPlaformsBg1.src,
        pictogram: sr1sr2ProductDevicesPlaformsPict2.src,
      },
      {
        platform: { ko: '클라우드', en: 'Cloud' },
        device: {
          ko: 'AWS EC2 인스턴스, MS Azure NP 인스턴스',
          en: 'AWS EC2 Instance, MS Azure NP Instance',
        },
        bgImg: sr1sr2ProductDevicesPlaformsBg2.src,
        pictogram: sr1sr2ProductDevicesPlaformsPict1.src,
      },
    ],
    productProvide: [
      {
        name: 'SDK',
        text: {
          ko: 'GPU 서버에 성능 최적화된 SDK 형태로 제공되며 FFmpeg 프레임워크 지원으로 어떠한 미디어 워크플로우에도 간단히 통합될 수 있습니다.',
          en: 'Provided as an SDK optimized for GPU/FPGA accelerator cards and supports the FFmpeg framework, making it simple to integrate into your media workflow.',
        },
      },
      {
        name: 'UI Service',
        text: {
          ko: '서비스 사업자를 위한 파일 기반의 영상 변환 클라우드 서비스를 제공합니다.',
          en: 'Offers file-based video upscaling cloud service for content providers.',
        },
      },
    ],
  },
  // ################################################################ pqo ################################################################

  pqo: {
    banner: {
      bannerImg: pqoBannerImg,
      bannerTitle: 'DeepField-PQO',
      bannerText: {
        ko: '인공지능 기술로 입력 영상을 전처리하여 영상의 화질은 유지하면서 코덱의 압축 효율을 높입니다.',
        en: 'AI technology is used to preprocess the input video in order to increase the compression efficiency of the codec while preserving video quality.',
      },
    },
    productDescription: {
      productDescriptionImg: pqoProductDescImg,
      productTitle: {
        ko: ['비디오 픽셀을 최적화하여', '인코딩 효율을 향상'],
        en: ['Optimize video pixels', 'to improve encoding efficiency'],
      },
      productText: {
        ko: [
          '시청자가 인지하는 화질의 열화가 없지만 영상 압축 성능이 향상될 수 있도록 인코딩 과정의 특성을 고려하여 학습된 인공지능 모델입니다.',
          '어떠한 코덱(codec agnostic)과도 함께 사용할 수 있으며 압축 효율을 최대화 합니다.',
          '컴퓨팅 인프라 비용의 상승등을 이유로 차세대 압축 코덱으로 교체가 어려운 경우, 사용중인 코덱에 적용할 수 있으며 평균 30%의 영상 저장 및 송출 비용을 줄일 수 있습니다.',
        ],
        en: [
          'It is an artificial intelligence model trained in consideration of the encoding process so that there is no perceived quality degradation by viewers, but video compression efficiency can be improved.',
          'It works with any codec and improves compression efficiency.',
          'If replacing with the next-generation compression codec is impractical owing to increased computing infrastructure costs, it can be applied to the existing codec, lowering the cost of storage and network by 30% on average.',
        ],
      },
    },
    productFeatures: {
      featureItems: [
        {
          featureName: {
            ko: '인지화질 최적화',
            en: 'Perceptual video quality optimization',
          },
          featureText: {
            ko: [
              '학습된 인공지능 모델로 인간의 인지 화질에 영향을 주는 부분의 디테일을 향상 시키고 중요하지 않은 부분의 디테일을 줄여 고화질 영상 압축에 필요한 데이터 사용량을 절감합니다. 인지적 화질의 열화 없이 고품질의 영상 압축에 필요한 데이터 사용량을 절감합니다.',
            ],
            en: [
              'The pretrained AI model enhances the details of areas that affect human perception quality while decreasing the details of minor areas. It reduces the amount of data required for video compression while maintaining perceptual video quality.',
            ],
          },
          mobileVids: [pqoVideo1],
          vids: [pqoVideo1],
        },
      ],
    },
    devicesPlatforms: [
      {
        platform: { ko: '온프레미스', en: 'On premises' },
        device: {
          ko: '엔비디아 GPU 카드, 자일링스 알베오 FPGA 카드',
          en: 'Nvidia GPU Card, Xilinx ALVEO FPGA Card',
        },
        bgImg: sr1sr2ProductDevicesPlaformsBg1.src,
        pictogram: sr1sr2ProductDevicesPlaformsPict2.src,
      },
      {
        platform: { ko: '클라우드', en: 'Cloud' },
        device: {
          ko: 'AWS EC2 인스턴스, MS Azure NP 인스턴스',
          en: 'AWS EC2 instances, MS Azure NP instances',
        },
        bgImg: sr1sr2ProductDevicesPlaformsBg2.src,
        pictogram: sr1sr2ProductDevicesPlaformsPict1.src,
      },
    ],
    productProvide: [
      {
        name: 'SDK',
        text: {
          ko: 'GPU/FPGA 서버에 성능 최적화된 SDK 형태로 제공되며 FFmpeg 프레임워크 지원으로 어떠한 미디어 워크플로우에도 간단히 통합될 수 있습니다.',
          en: 'Provided as an SDK optimized for GPU/FPGA accelerator cards and supports the FFmpeg framework, making it simple to integrate into your media workflow.',
        },
      },
      {
        name: 'Silicon IP',
        text: {
          ko: '블루닷의 딥필드 제품은 서버용 미디어 프로세싱 FPGA 또는 ASIC에 통합될 수 있는 반도체 IP으로도 제공되며, 최고의 성능을 경험할 수 있습니다.',
          en: 'The product is also available as Semiconductor IP that can be integrated into media processing FPGAs or ASICs for servers for optimal performance.',
        },
      },
      {
        name: 'UI Service',
        text: {
          ko: '서비스 사업자를 위한 파일 기반의 영상 변환 클라우드 서비스를 제공합니다.',
          en: 'Offers file-based video upscaling cloud service for content providers.',
        },
      },
    ],
  },
};
